import FlexBox from './FlexBox';
import { Span } from './Typography';
import CallOutlined from '@mui/icons-material/CallOutlined';
import MailOutline from '@mui/icons-material/MailOutlineSharp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Container, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { layoutConstant } from 'constants';
import { stringConstants } from 'constants';
import React from 'react';
import { useTheme } from '@mui/material/styles';

const TopbarWrapper = styled('div')(({ theme }) => ({
  height: layoutConstant.topbarHeight,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  fontSize: 12,
  '& .topbarRight': {
    '& .link': {
      paddingRight: 30,
      color: theme.palette.text.secondary
    },
    '@media only screen and (max-width: 900px)': {
      '& .link': {
        display: 'none'
      }
    }
  },
  '& .topbarLeft': {
    '& .link': {
      paddingLeft: 30,
      color: theme.palette.text.secondary
    },
    '@media only screen and (max-width: 900px)': {
      '& .link': {
        display: 'none'
      }
    }
  },
  '& .smallRoundedImage': {
    height: 15,
    width: 25,
    borderRadius: 2
  },
  '& .handler': {
    height: layoutConstant.topbarHeight
  },
  '& .menuTitle': {
    fontSize: 12,
    marginLeft: '0.5rem',
    fontWeight: 600
  },
  '& .menuItem': {
    minWidth: 100
  },
  '& .marginRight': {
    marginRight: '1.25rem'
  }
}));

// GOTOBED TOPBAR COMPONENT
const Topbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <TopbarWrapper>
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
          backgroundColor: '',
          // The default gutters cost ~48px, which is what pushed the email off a phone screen.
          px: { xs: 1, md: 3 }
        }}>
        {/* On mobile this row owns the full width and splits phone/email to the two edges, so both
            fit at 40px tall without wrapping. */}
        <FlexBox
          className="topbarLeft"
          alignItems="center"
          sx={{
            flex: { xs: 1, md: 'none' },
            justifyContent: { xs: 'space-between', md: 'flex-start' },
            minWidth: 0
          }}>
          {/* No padding on these icons: CssBaseline makes them border-box, so padding is taken
              out of the 1em glyph rather than added around it. Space them with margin instead. */}
          <FlexBox alignItems="center" sx={{ minWidth: 0 }}>
            <CallOutlined sx={{ fontSize: 18, mr: 0.75, color: 'gold.fill' }} />
            <Span color="text.secondary" sx={{ fontSize: { xs: 12, md: 14 }, whiteSpace: 'nowrap' }}>
              {stringConstants.phone}
            </Span>
          </FlexBox>

          <FlexBox alignItems="center" sx={{ ml: { xs: 1, md: 2.5 }, minWidth: 0 }}>
            <MailOutline sx={{ fontSize: 18, mr: 0.75, color: 'gold.fill' }} />
            <Span color="text.secondary" sx={{ fontSize: { xs: 12, md: 14 }, whiteSpace: 'nowrap' }}>
              {stringConstants.email}
            </Span>
          </FlexBox>
        </FlexBox>

        {!isMobile && (
          <FlexBox className="topbarRight" alignItems="center">
            <AccessTimeIcon sx={{ fontSize: 18, mr: 0.75, color: 'gold.fill' }} />
            <Span className="title" color="text.secondary" sx={{ fontSize: 14 }}>
              {stringConstants.workingHours}
            </Span>
          </FlexBox>
        )}
      </Container>
    </TopbarWrapper>
  );
};

export default Topbar;
